export const primaryDark = '#6b0313';
export const primary = '#840417';
export const bright = 'white';
export const textColor = '#222';
export const textLight = '#333';
export const textLighter = '#444';



// WEBPACK FOOTER //
// ./app/colors.js